import { render, staticRenderFns } from "./InterestForm.vue?vue&type=template&id=12b7f116&scoped=true"
import script from "./InterestForm.vue?vue&type=script&lang=js"
export * from "./InterestForm.vue?vue&type=script&lang=js"
import style0 from "./InterestForm.vue?vue&type=style&index=0&id=12b7f116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b7f116",
  null
  
)

export default component.exports